export default __webpack_public_path__ + "static/media/pol1l.ed69b5e7.svg";